import React, { Component } from 'react';
import Card from '../../components/card/Card';
import CardHeader from '../../components/cardHeader/CardHeader';
import Label from '../../components/label/Label';
import mainAPI from '../../api/MainAPI';
import { getDrugName } from '../../utils/gramUtils';

export default class DrugOrderFormSummaryCard extends Component {
	constructor(props) {
		super(props);
		this.state = {
			drugSummary: {}
		};
	}

	componentDidMount = () => {
		if (this.props.drugOrderFormId) {
			this._getDrugSummary();
		}
	};

	componentDidUpdate = (prevProps) => {
		if (this.props.drugOrderFormId !== prevProps.drugOrderFormId) {
			this._getDrugSummary();
		}
	};

	refresh = async () => {
		await this._getDrugSummary();
	};

	_getDrugSummary = async () => {
		const { drugOrderFormId } = this.props;
		if (!drugOrderFormId) {
			return;
		}

		try {
			const response = await mainAPI.drug.paginated({
				used_drugs: false,
				drug_order_form_id: drugOrderFormId,
				limit: 10000
			});

			const drugs = Array.isArray(response) ? response : (response && response.data ? response.data : []);
			const summary = {};

			drugs.forEach(drug => {
				if (drug && drug.type) {
					summary[drug.type] = (summary[drug.type] || 0) + 1;
				}
			});

			this.setState({ drugSummary: summary });
		} catch (error) {
			console.error('Error fetching drug summary:', error);
		}
	};

	render() {
		const { drugSummary } = this.state;
		const summaryEntries = Object.keys(drugSummary).sort((a, b) => {
			const nameA = getDrugName(a).toLowerCase();
			const nameB = getDrugName(b).toLowerCase();
			return nameA.localeCompare(nameB);
		});

		if (summaryEntries.length === 0) {
			return (
				<Card className="g-drug-order-form-drugs-card">
					<div className="g-drug-order-form-drug-summary">
						<CardHeader>Drug Summary</CardHeader>
						<Label black bold>Nothing Selected</Label>
					</div>
				</Card>
			);
		}

		return (
			<Card className="g-drug-order-form-drugs-card">
				<CardHeader>Drug Summary</CardHeader>
				<div className={'cards'}>
					{summaryEntries.map(drugType => {
						const count = drugSummary[drugType];
						const name = getDrugName(drugType);
						return (
							<Card key={drugType} className={'drug-count'}>
								<Label black bold>{name}</Label>
								<Label blue very-large>{count}</Label>
							</Card>
						);
					})}
				</div>
			</Card>
		);
	}
}




// WEBPACK FOOTER //
// ./src/pages/drugOrderFormDetailsPage/DrugOrderFormSummaryCard.jsx